import { render, staticRenderFns } from "./CheckForLatestVersion.vue?vue&type=template&id=54444394&"
import script from "./CheckForLatestVersion.vue?vue&type=script&lang=js&"
export * from "./CheckForLatestVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports